import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductDetailsComponent } from './product-details.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'product-details/:id/:segment',
        component: ProductDetailsComponent,
        canActivate: [AuthGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver}
      },
      {
        path: 'product-details/:id',
        redirectTo: 'product-details/:id/item-details',
        pathMatch: 'full',
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver}
      },
      {
        path: 'product-details/:id/:segment/panel',
        component: ProductDetailsComponent,
        canActivate: [AuthGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository'] },
        resolve: { permissions: PermissionsResolver}
      },
    ])
  ],
  exports: [RouterModule]
})
export class ProductDetailsRoutingModule { }
